import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IReorderModifierGroupPayload } from './types';

export const reorderModifierGroup = (itemId: string, requestBody: IReorderModifierGroupPayload): Promise<Response> => {
  const url = `${API_URL}/items/${itemId}/modifier-groups/reorder`;
  return fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    cache: 'reload',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
